import type React from 'react';

import { StraightArrowUpRightIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import { Link } from 'react-router-dom';

import { useGoToCardTranslation } from './i18n';
import { generateLink } from './link';
import type { GoToCardProps } from './types';

interface GoToCardButtonProps extends GoToCardProps, ButtonProps {
}

function GoToCardButton({
  cardId,
  ...props
}: GoToCardButtonProps): React.JSX.Element {
  const { t } = useGoToCardTranslation();
  return (
    <Button
      as={Link}
      data-testid="FaceId.goToFaceCard"
      to={generateLink(cardId)}
      icon={<StraightArrowUpRightIcon />}
      kind="secondary"
      size="small"
      {...props}
    >
      {t('title')}
    </Button>
  );
}

export { GoToCardButton };
